import { defineStore } from 'pinia'

export const useCompraBoletosStore = defineStore('compraBoletos', {
  state: () => ({
    // Boleto seleccionado
    boleto: {
      idBoleto:       0,
      nombreBoleto:   '',
      tipoBoleto:     '',   // 'general' | 'primera_fila' | 'mesa_vip' | 'streaming'
      cantidad:       1,
      precioUnitario:  0,
      peleadorId:      null,
      peleadorNombre:  '',
    },

    // Datos del comprador
    comprador: {
      nombre:          '',
      apellido:        '',
      email:           '',
      confirmEmail:    '',
      telefono:        '',
      fechaNacimiento: '',
      esAsistente:     true,
    },

    // Control de flujo
    aceptaTerminos: false,

    // Resultado del pago (se llena tras confirmar)
    pago: {
      compraId:         null,
      clientSecret:     null,
      paymentIntentId:  null,
      intentosFallidos: 0,   // cuántas veces Stripe rechazó con este PaymentIntent
    },
  }),

  actions: {
    resetFormulario() {
      this.$reset()
    },

    setBoleto(boleto) {
      this.boleto.idBoleto       = boleto.id
      this.boleto.nombreBoleto   = boleto.nombre
      this.boleto.tipoBoleto     = boleto.tipo
      this.boleto.precioUnitario = parseFloat(boleto.precio ?? boleto.precioUnitario) || 0
    },

    // Limpia solo el bloque de pago para forzar un nuevo PaymentIntent.
    // Se llama cuando el usuario quiere empezar de cero tras demasiados fallos,
    // o cuando navega de regreso al Step1/Step2 y cambia datos del comprador.
    clearPago() {
      this.pago.compraId         = null
      this.pago.clientSecret     = null
      this.pago.paymentIntentId  = null
      this.pago.intentosFallidos = 0
    },

    // Normaliza el estado por si viene rehidratado desde una versión anterior
    // del store (sin intentosFallidos). Se llama en onMounted del Step3.
    normalizarPago() {
      if (typeof this.pago.intentosFallidos !== 'number') {
        this.pago.intentosFallidos = 0
      }
    },
  },

  getters: {
    totalCompra(state) {
      return (parseFloat(state.boleto.precioUnitario) || 0) * (parseInt(state.boleto.cantidad) || 1)
    },

    payloadCompra(state) {
      return {
        tipo_boleto: state.boleto.idBoleto,
        cantidad:    state.boleto.cantidad,
        terminos_aceptados: state.aceptaTerminos,
        peleador_elegido: state.boleto.peleadorId,
        comprador: {
          nombre:           state.comprador.nombre,
          apellido:         state.comprador.apellido,
          email:            state.comprador.email,
          fecha_nacimiento: state.comprador.fechaNacimiento,
          telefono:         state.comprador.telefono,
          es_asistente:     state.comprador.esAsistente,
        },
      }
    },

    // True si ya tenemos un PaymentIntent activo y reutilizable para este intento
    tieneIntentActivo(state) {
      return !!(state.pago.clientSecret && !state.pago.paymentIntentId)
    },
  },

  persist: true,
})